// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3tY2z","empty":"ModalGraph_empty__3CM6g"};